import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../core/services/authentication.service';
import { CookieService } from 'ngx-cookie';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';

@Component({
    selector: 'app-youtube-authentication',
    templateUrl: './youtube-authentication.component.html',
    styleUrls: ['./youtube-authentication.component.scss'],
    imports: [LoaderComponent],
})
export class YoutubeAuthenticationComponent implements OnInit {
    code: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private cookieService: CookieService,
    ) {}

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            const authData = this.authenticationService.getAuthenticationData();

            this.code = params['code'];

            if (this.code) {
                this.authenticationService.youtubeCode = this.code;
                this.cookieService.put('youtubeOAuthCode' + authData.token, this.code);
            }

            setTimeout(() => {
                this.router.navigate(['./', authData.portalName], {
                    relativeTo: this.activatedRoute.parent,
                    queryParams: { r: authData.token },
                });
            }, 10);
        });
    }
}
